<template>
    <div class="main-panel">

        <section class="winner-section">
         
            <div>
                <h1 class="search-title pl-2">Select The Winner</h1>
                <div class="result-title">

                    <div class="search-content">
                        <select class="dropdown" v-model="selectedCompetitionId">
                            <option disabled :value="null">Select a competition</option>
                            <option v-for="competition in endedCompetitionsWithoutWinners"
                                    :key="competition.competitionId"
                                    :value="competition.competitionId">
                                {{ competition.competitionName }} (WSP{{competition.competitionId}})
                            </option>
                        </select>

                        <button class="select-winner-button"
                                @click="selectWinner"
                                :disabled="isSubmitting">
                            <span v-if="!isSubmitting">Select The Winner</span>
                            <LoaderDots v-if="isSubmitting" />
                        </button>
                    </div>

                </div>
                <div class="content">

                    <div class="search-title ">Prizes</div>

                    <p>Enter the competition prizes, one prize on per line. Letters and numbers only, no spaces or special charecters.</p>

                    <div class="prize-grid">

                        <textarea id="prizes" rows="20" v-model="prizes"></textarea>

                    </div>

                    <div class="search-title" v-if="winnerDetailsList.length">User Details</div>

                    <div v-if="loadingWinner" class="loader">Loading winner details...</div>
                                       

                    <div v-else class="info-grid" v-for="(winner, index) in winnerDetailsList" :key="index">

                        <label for="compid"><strong>Prize:</strong></label>
                        <input id="compid" name="compid" disabled :value="winner.prize" readonly>

                        <label for="compid"><strong>Competition Id:</strong></label>
                        <input id="compid" name="compid" disabled :value="winner.competitionId" readonly>

                        <label for="numticktes"><strong>Number of Tickets Entered:</strong></label>
                        <input id="numticktes" name="numticktes" disabled :value="winner.numberOfTicketsEntered" readonly>

                        <label for="hash"><strong>Hash:</strong></label>
                        <textarea id="hash" disabled name="hash" rows="5" cols="33">{{ winner.hash }}</textarea>

                        <label for="signature"><strong>Kms Signature:</strong></label>
                        <textarea id="signature" disabled name="signature" rows="5" cols="33">{{ winner.kmsSignature }}</textarea>

                        <label for="ransignature"><strong>Random.org Signature:</strong></label>
                        <textarea id="ransignature" disabled name="signature" rows="5" cols="33">{{ winner.randomOrgSignature }}</textarea>

                        <label for="winticket"><strong>Winning Ticket:</strong></label>
                        <input id="winticket" name="winticket" disabled :value="winner.winningTicket" readonly>

                        <label for="winuserid"><strong>Winning User Id:</strong></label>
                        <input id="winuserid" name="winuserid" disabled :value="winner.userId" readonly>

                        <br/>
                        <a v-if="showWinnerSection" target="_blank" class="goto-winner-button" :href="`/users/${winner.userId}`">
                            see winner details
                        </a>
                    </div>

                </div>
                </div>
        </section>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import competitionService from "../services/competition-service";
import winnersService from "../services/winners-service";
import endedCompetitionsWithoutWinnersResponse from "../responses/EndedCompetitionsWithoutWinnersResponse";
import winnerDetailsResponse from "../responses/WinnerDetailsResponse";
import { showAlert } from "../utils/global";
    import LoaderDots from "../components/LoadingButtonDots.vue";

    import Swal from 'sweetalert2'

    export default defineComponent({
        components: {
            LoaderDots,
        },
  setup() {
    const endedCompetitionsWithoutWinners = ref<
      endedCompetitionsWithoutWinnersResponse[]
    >([]);
    const selectedCompetitionId = ref<number | null>(null);
    const winnerDetails = ref<winnerDetailsResponse>(
      {} as winnerDetailsResponse
      );

      const winnerDetailsList = ref<winnerDetailsResponse[]>([])

    const loadingWinner = ref(false);
      const showWinnerSection = ref(false);

      const isSubmitting = ref(false); // New state for button disabling

      const prizes = ref<string>('');

      const MAX_LENGTH = 50;
      const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/;

      const prizeList = computed(() =>
          prizes.value
              .split(/\r?\n/)
              .map(p => p.trim())
              .filter(Boolean)
      );

    const getEndedCompetitionsWithoutWinners = async () => {
        try {

         
        const response =
          await competitionService.getEndedCompetitionsWithoutWinners();
            endedCompetitionsWithoutWinners.value = response;
            
      } catch (error) {
        console.error(
          "Error fetching ended competitions without winners:",
            error
         
            );
           
      }
    };

    onMounted(async () => {
      await getEndedCompetitionsWithoutWinners();
    });

      const validatePrizes = (): boolean => {
          if (prizeList.value.length === 0) {
              showAlert(
                  "No prizes entered",
                  `Please add at least one prize before selecting a winner.`,
                  "error"
              )
              return false
          }

          const invalidCharacters = prizeList.value.filter(
              prize => !ALPHANUMERIC_REGEX.test(prize)
          )

          if (invalidCharacters.length > 0) {
              showAlert(
                  "Invalid characters",
                  `Only letters and numbers are allowed.`,
                  "error"
              )
              return false
          }

          const tooLong = prizeList.value.filter(
              prize => prize.length > MAX_LENGTH
          )

          if (tooLong.length > 0) {
              showAlert(
                  "Prize too long",
                  `Each prize must be ${MAX_LENGTH} characters or fewer.`,
                  "error"
              )
              return false
          }

          return true;
      }

      const confirmPrizes = async (): Promise<boolean> => {
          const listHtml = prizeList.value
              .map((p, i) => `${i + 1}. ${p}<br/>`)
              .join('');

          const listTitle = `Total Prizes: ${prizeList.value.length}`;

          const result = await Swal.fire({
              icon: 'question',
              title: listTitle,
              html: `
      <p>
        ${listHtml}</p>
      <p style="margin-top: 1rem;">Continue?</p>
    `,
              showCancelButton: true,
              confirmButtonText: 'Yes, continue',
              cancelButtonText: 'Cancel'
          });

          return result.isConfirmed;
      }


      const selectWinner = async () => {

          if (!validatePrizes()) return;

          const confirmed = await confirmPrizes();

          if (!confirmed) return;

          if (!selectedCompetitionId.value) return;

          winnerDetailsList.value = [];

          loadingWinner.value = true;
          showWinnerSection.value = true;

          const excludedTicketsList = ref<string[]>([]);

          try {

              isSubmitting.value = true;
              const competitionId = selectedCompetitionId.value;

              for (const prize of prizeList.value) {

                  //const response = await winnersService.selectCompetitionWinner(competitionId);

                  const response = await winnersService.selectCompetitionWinner(competitionId, {
                      isTest: false,
                      prize: prize,
                      excludedTickets: excludedTicketsList.value
                  })

                  if (response.isSuccess) {

                      winnerDetails.value = response;
                      winnerDetails.value.prize = prize;

                      winnerDetailsList.value.push(winnerDetails.value);
                      excludedTicketsList.value.push(winnerDetails.value.winningTicket);

                  } else {
                      showWinnerSection.value = false;
                      isSubmitting.value = false;

                      showAlert(
                          "Failed to Select Winner",
                          `There was a problem selecting the winner: ${response.message}`,
                          "error"
                      );
                  }
              }
          } catch (error: any) {
              const message =
                  error?.response?.data?.errors?.[0] ??
                  error?.response?.data?.message ??
                  error?.message ??
                  "An unexpected error occurred.";

              showAlert(
                  "Failed to Select Winner",
                  `An error occured while selecting the winner: ${message}`,
                  "error"
              );
          } finally {
              loadingWinner.value = false;
              isSubmitting.value = false;
          }
      };

    return {
      endedCompetitionsWithoutWinners,
      selectedCompetitionId,
      selectWinner,
      winnerDetails,
      loadingWinner,
        showWinnerSection,
        isSubmitting,
        prizes,
        winnerDetailsList,
    };
  },
});
</script>

<style scoped>
/* .content {
    margin-bottom: 1rem;
  } */

    strong {
        font-weight:600;
    }

    .pl-2 {
        padding-left: 2rem;
    }

    .winner-section {
        width: calc(100% - 3rem);
     margin-inline: auto;
        display: grid;
        gap:1rem;
        margin-top: 3rem;
    }


    .result-title {
        position: relative;
        background-color: var(--clr-primary);
        padding: 1rem 1rem;
        margin-inline: 2rem;
        color: white;
        font-size: 24px;
        border-radius: 3px;
        box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
        z-index: 1;
    }

    .search-title {
        font-size: 1.8em;
        color: #726e6e;
        margin-bottom: 10px;
    }

    label {
        padding-top: 1rem;
    }

.dropdown {
  width: 100%;
  padding: 1rem;

  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: white;
}

.search-content {
    
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 2rem;
}


    @media (max-width: 450px) {

        .content {
            padding:  10px  !important;
        }

        .result-title {
            margin-inline: 0.2rem;
        }
    }

@media (max-width: 1350px){
    .search-content {
        grid-template-columns: 1fr;
        gap: 0.5rem;
    }


    
}

.content {
 
  margin: auto;
  position: relative;
  background-color: #fff;
  padding: 80px 40px 20px 40px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 3px;
  margin-top: -50px;

  padding-top: -30px;

}

.select-winner-button {
 
  background-color:orangered;
  width: 100%;
  color: white;
  font-size: 24px;
  border-radius: 3px;
  border: none;
  width: 100%;
  cursor: pointer;
  padding:1rem;
  height:60px;

}



    .goto-winner-button {
        margin: 10px 0;
        background-color: var(--clr-primary);
        padding: 1rem;
        color: white;
        font-size: 18px;
        border-radius: 3px;
        border: none;
        width: 100%;
        cursor: pointer;
        max-width: 300px;
        text-decoration: none;
        text-align: center;
    }

    .winner-details {
        padding: 80px 40px 20px 40px;
        background-color: white;
    }
.loader {
  font-weight: bold;
}

input,textarea {
    padding:1rem;

}

    .info-grid {
        display: grid;
        border: 1px solid black;
        padding: 20px;
        padding-top: 0px;   
        margin-bottom: 20px;
    }

    .prize-grid{
        display:grid;
        padding:20px;
        margin-bottom: 10px;
        height: 200px;
    }

</style>
